<template>
  <div @click="handleClick">
    <slot />
    <van-action-sheet
      v-model="visible"
      :title="title"
      :round="false"
      get-container="body"
      @click.native.stop
    >
      <div :class="[_.list, _._hairlineTop]">
        <x-grid :col-count="colCount" :gap="12">
          <template v-for="item in data">
            <slot
              name="item"
              :item="item"
              :pick="() => handleItemClick(item)"
              :picked="item.value === value"
            >
              <div
                :key="item.value"
                :class="[_.item, _._ellipsis, item.value === value && _.picked]"
                @click="handleItemClick(item)"
              >
                {{ item.label }}
              </div>
            </slot>
          </template>
        </x-grid>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      value: {
        type: null,
        required: true,
      },
      data: {
        type: Array,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      colCount: {
        type: Number,
        default: 3,
      },
    },

    data: () => ({
      visible: false,
    }),

    methods: {
      handleClick() {
        this.visible = !this.visible
      },
      handleItemClick(item) {
        this.visible = !this.visible
        this.$emit('input', item.value)
      },
    },
  })
</script>

<style lang="scss" module>
  .list {
    padding: 12px;

    .item {
      background: #f5f6f8;
      border-radius: 4px;
      font-size: 12px;
      color: #222222;
      padding: 11px 4px;
      text-align: center;

      &.picked {
        background: #fdf5e6;
        color: #f5a400;
      }

      &:active {
        opacity: 0.8;
      }
    }
  }
</style>
